(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hs-warming-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-hw-pdp]').forEach(function(root) {
  var thumbs = root.querySelectorAll('[data-hw-thumb]');
  var slides = root.querySelectorAll('[data-hw-slide]');
  thumbs.forEach(function(button) {
    button.addEventListener('click', function() {
      var index = button.getAttribute('data-hw-thumb');
      slides.forEach(function(slide) { slide.hidden = slide.getAttribute('data-hw-slide') !== index; });
      thumbs.forEach(function(thumb) { thumb.setAttribute('aria-pressed', thumb === button ? 'true' : 'false'); });
    });
  });
  var qty = root.querySelector('[data-hw-quantity]');
  var offerRadios = root.querySelectorAll('[data-hw-offer] input[type="radio"]');
  function updateOfferAmounts() {
    var unitCents = parseInt(root.getAttribute('data-hw-price-cents'), 10) || 0;
    root.querySelectorAll('[data-hw-offer-total]').forEach(function(total) {
      total.textContent = displayMoney(unitCents * (parseInt(total.getAttribute('data-hw-offer-total'), 10) || 1));
    });
    root.querySelectorAll('[data-hw-unit-price]').forEach(function(unit) { unit.textContent = displayMoney(unitCents); });
  }
  offerRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      if (!radio.checked) return;
      if (qty) qty.value = radio.value;
      root.querySelectorAll('[data-hw-offer]').forEach(function(offer) { offer.classList.toggle('hw-offer--selected', offer.contains(radio)); });
    });
  });
  var variant = root.querySelector('[data-hw-variant]');
  if (variant) variant.addEventListener('change', function() {
    var option = variant.options[variant.selectedIndex];
    var price = root.querySelector('[data-hw-current-price]');
    var stickyPrice = root.querySelector('.hw-sticky__label span');
    if (price) price.textContent = option.getAttribute('data-price');
    if (stickyPrice) stickyPrice.textContent = option.getAttribute('data-price');
    root.setAttribute('data-hw-price-cents', option.getAttribute('data-cents'));
    updateOfferAmounts();
    var enabled = option.getAttribute('data-available') === 'true';
    root.querySelectorAll('[data-hw-add-to-cart], .hw-sticky__button').forEach(function(button) { button.disabled = !enabled; });
  });
  var primary = root.querySelector('[data-hw-add-to-cart]');
  var sticky = root.querySelector('[data-hw-sticky]');
  if (primary && sticky && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
    }, { threshold: .05 });
    observer.observe(primary);
  }
  var cartDialog = document.querySelector('[data-hw-cart-dialog]');
  var rootUrl = cartDialog ? cartDialog.getAttribute('data-root-url') : '/';
  var cartUrl = cartDialog ? cartDialog.getAttribute('data-cart-url') : '/cart';
  var cartLink = document.querySelector('[data-hw-cart-trigger]');
  var productForm = root.querySelector('.hw-form');
  var errorMessage = root.querySelector('[data-hw-cart-error]');
  var moneyFormatter;
  try {
    moneyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD' });
  } catch (error) {
    moneyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  }
  function displayMoney(cents) { return moneyFormatter.format((Number(cents) || 0) / 100); }
  function renderCart(cart) {
    if (!cartDialog) return;
    var list = cartDialog.querySelector('[data-hw-cart-items]');
    var total = cartDialog.querySelector('[data-hw-cart-total]');
    var checkout = cartDialog.querySelector('.hw-cart-dialog__checkout');
    list.replaceChildren();
    if (!cart.items || !cart.items.length) {
      var empty = document.createElement('p');
      empty.className = 'hw-cart-dialog__empty';
      empty.textContent = cartDialog.getAttribute('data-empty');
      list.appendChild(empty);
    } else {
      cart.items.forEach(function(item) {
        var row = document.createElement('div');
        row.className = 'hw-cart-dialog__item';
        var picture = document.createElement('img');
        if (item.image) picture.src = item.image;
        picture.alt = item.product_title || '';
        picture.loading = 'lazy';
        var description = document.createElement('div');
        var name = document.createElement('strong');
        name.textContent = item.product_title || item.title;
        var detail = document.createElement('span');
        detail.textContent = cartDialog.getAttribute('data-quantity') + ' ' + item.quantity + ' · ' + displayMoney(item.final_line_price);
        description.appendChild(name);
        description.appendChild(detail);
        var quantityInput = document.createElement('input');
        quantityInput.type = 'number';
        quantityInput.min = '0';
        quantityInput.step = '1';
        quantityInput.value = item.quantity;
        quantityInput.setAttribute('aria-label', cartDialog.getAttribute('data-quantity') + ': ' + name.textContent);
        quantityInput.style.cssText = 'width:70px;padding:7px;margin-top:10px;border:1px solid #bcc8be;border-radius:4px';
        quantityInput.addEventListener('change', function() {
          var next = Number(quantityInput.value);
          if (Number.isInteger(next) && next >= 0) changeCartItem(item.key, next);
          else quantityInput.value = item.quantity;
        });
        var removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.textContent = cartDialog.getAttribute('data-remove');
        removeButton.style.cssText = 'border:0;background:transparent;text-decoration:underline;margin-left:12px;cursor:pointer;font-size:12px';
        removeButton.addEventListener('click', function() { changeCartItem(item.key, 0); });
        description.appendChild(quantityInput);
        description.appendChild(removeButton);
        row.appendChild(picture);
        row.appendChild(description);
        list.appendChild(row);
      });
    }
    if (total) total.textContent = displayMoney(cart.total_price);
    if (checkout) {
      checkout.setAttribute('aria-disabled', cart.item_count ? 'false' : 'true');
      checkout.style.opacity = cart.item_count ? '1' : '.45';
    }
  }
  async function changeCartItem(key, quantity) {
    var updateError = cartDialog.querySelector('[data-hw-cart-update-error]');
    updateError.hidden = true;
    cartDialog.querySelectorAll('input,button').forEach(function(control) { control.disabled = true; });
    try {
      var response = await fetch(rootUrl + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:quantity}),credentials:'same-origin'});
      var payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || cartDialog.getAttribute('data-error'));
      renderCart(payload);
    } catch (error) {
      updateError.textContent = error.message || cartDialog.getAttribute('data-error');
      updateError.hidden = false;
    } finally {
      cartDialog.querySelectorAll('input,button').forEach(function(control) { control.disabled = false; });
    }
  }
  async function openCart() {
    if (!cartDialog || typeof cartDialog.showModal !== 'function') {
      window.location.assign(cartUrl);
      return;
    }
    var response = await fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!response.ok) throw new Error(cartDialog.getAttribute('data-error'));
    renderCart(await response.json());
    if (!cartDialog.open) cartDialog.showModal();
  }
  if (cartDialog) {
    cartDialog.querySelectorAll('[data-hw-cart-close]').forEach(function(button) { button.addEventListener('click', function() { cartDialog.close(); }); });
    cartDialog.addEventListener('click', function(event) { if (event.target === cartDialog) cartDialog.close(); });
    var checkoutLink = cartDialog.querySelector('.hw-cart-dialog__checkout');
    if (checkoutLink) checkoutLink.addEventListener('click', function(event) { if (checkoutLink.getAttribute('aria-disabled') === 'true') event.preventDefault(); });
  }
  if (cartLink && Number(root.getAttribute('data-hw-app-count')) === 0) cartLink.addEventListener('click', async function(event) {
    event.preventDefault();
    try { await openCart(); } catch (error) { window.location.assign(cartUrl); }
  });
  if (productForm && Number(root.getAttribute('data-hw-app-count')) === 0) productForm.addEventListener('submit', async function(event) {
    event.preventDefault();
    if (errorMessage) errorMessage.hidden = true;
    var buttons = root.querySelectorAll('[data-hw-add-to-cart], .hw-sticky__button');
    var previousDisabled = Array.from(buttons).map(function(button) { return button.disabled; });
    buttons.forEach(function(button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    try {
      var response = await fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(productForm), credentials: 'same-origin' });
      var payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || cartDialog.getAttribute('data-error'));
      await openCart();
    } catch (error) {
      if (errorMessage) { errorMessage.textContent = error.message || cartDialog.getAttribute('data-error'); errorMessage.hidden = false; }
    } finally {
      buttons.forEach(function(button, index) { button.disabled = previousDisabled[index]; button.removeAttribute('aria-busy'); });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-welcome-popup"]) return;
  try {
    

  (function () {
    /* Isolated: any error here only disables the popup, never the page */
    try { init(); } catch (err) { if (window.console) console.warn('[of-sp]', err); }

    function init() {
      var root = document.getElementById('of-sp');
      if (!root) return;

      var KEYS = {
        subscribed: 'of_sp_subscribed',
        dismissedAt: 'of_sp_dismissed_at',
        shownThisVisit: 'of_sp_shown_visit',
        visitStart: 'of_sp_visit_start'
      };
      var DAY = 86400000;
      var REVEAL_AT = 0.6; /* share of the foil scratched before the email field appears */
      var params = new URLSearchParams(location.search);
      var testMode = params.get('hs_popup') === 'test';
      var pending = get('sessionStorage','hs_sp_pending') === '1';
      var postSuccess = pending && !!root.querySelector('[data-hs-welcome-success]');
      var postError = pending && !!root.querySelector('[data-hs-welcome-error]');

      function get(store, key) { try { return window[store].getItem(key); } catch (e) { return null; } }
      function set(store, key, val) { try { window[store].setItem(key, val); } catch (e) {} }

      /* Known subscribers: arrived from a Klaviyo email, or just used the footer signup */
      var utmSource = (params.get('utm_source') || '').toLowerCase();
      if (params.has('_kx') || utmSource.indexOf('klaviyo') > -1 || params.get('utm_medium') === 'email' || params.get('customer_posted') === 'true') {
        set('localStorage', KEYS.subscribed, '1');
      }

      if (!testMode && !postSuccess && !postError) {
        if (window.Shopify && Shopify.designMode) return;
        if (get('localStorage', KEYS.subscribed)) return;
        if (get('sessionStorage', KEYS.shownThisVisit)) return;
        var dismissedAt = Number(get('localStorage', KEYS.dismissedAt) || 0);
        if (dismissedAt && Date.now() - dismissedAt < Number(root.dataset.snoozeDays) * DAY) return;
      }

      var panel = root.querySelector('.of-sp__panel');
      var offer = root.querySelector('[data-of-sp-step="offer"]');
      var success = root.querySelector('[data-of-sp-step="success"]');
      var title = root.querySelector('[data-of-sp-title]');
      var form = root.querySelector('.of-sp__form');
      var input = root.querySelector('#of-sp-email');
      var error = root.querySelector('.of-sp__error');
      var submit = form.querySelector('button[type="submit"]');
      var canvas = root.querySelector('.of-sp__foil');
      var ctx = null;
      var opened = false;
      var revealed = false;
      var subscribed = false;
      var lastFocus = null;

      /* ---- Triggers ---- */

      /* Timer counts from the first allowed page of this visit. Advertorials skip it. */
      var start = Number(get('sessionStorage', KEYS.visitStart) || 0);
      if (!start) { start = Date.now(); set('sessionStorage', KEYS.visitStart, String(start)); }
      var wait = testMode ? 1000 : Math.max(0, Number(root.dataset.delay) * 1000 - (Date.now() - start));
      if (testMode || root.dataset.exitOnly !== 'true') setTimeout(openWhenFree, wait);

      /* Exit intent: can open it before the timer. Armed after 3s on the page. */
      setTimeout(function () {
        if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          /* Desktop: pointer leaves through the top of the window (tabs, address bar, close) */
          document.addEventListener('mouseout', function (e) {
            if (!e.relatedTarget && e.clientY <= 0) openOnExit();
          });
        } else {
          /* Phones: a fast scroll back up after reading down the page */
          var lastY = window.scrollY, lastT = Date.now(), maxY = lastY;
          window.addEventListener('scroll', function () {
            var y = window.scrollY, t = Date.now();
            maxY = Math.max(maxY, y);
            var speed = (lastY - y) / Math.max(1, t - lastT); /* px per ms, upward */
            if (maxY > 600 && lastY - y > 60 && speed > 1.5) openOnExit();
            lastY = y; lastT = t;
          }, { passive: true });
        }
      }, testMode ? 0 : 3000);

      function openOnExit() {
        if (!opened && !busy()) open();
      }

      var tries = 0;
      function openWhenFree() {
        if (opened) return;
        if (busy()) { if (++tries < 30) setTimeout(openWhenFree, 2000); return; }
        open();
      }

      /* Don't interrupt: skip while the cart drawer or any other modal is on screen */
      function isVisible(el) {
        if (!el || !el.getClientRects().length) return false;
        var st = getComputedStyle(el);
        if (st.display === 'none' || st.visibility === 'hidden' || Number(st.opacity) === 0) return false;
        var r = el.getBoundingClientRect();
        return r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 && r.top < window.innerHeight && r.left < window.innerWidth;
      }
      function busy() {
        if (document.querySelector('cart-drawer.active, cart-drawer.is-visible')) return true;
        if (document.querySelector('details[open] > .modal__content, details[open] > .menu-drawer')) return true;
        /* includes Shopify's cookie consent banner (role="alertdialog"): let them answer it first */
        var dialogs = document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"], [role="alertdialog"]');
        for (var i = 0; i < dialogs.length; i++) {
          if (!root.contains(dialogs[i]) && isVisible(dialogs[i])) return true;
        }
        return isVisible(document.getElementById('cw-popup-pdp-overlay'));
      }

      /* ---- Open / close ---- */

      function open() {
        if (opened) return;
        opened = true;
        set('sessionStorage', KEYS.shownThisVisit, '1');
        lastFocus = document.activeElement;
        try {
          root.hidden = false;
          document.documentElement.classList.add('of-sp-lock');
          watchViewport(true);
          drawFoil();
          root.querySelector('.of-sp__close').focus({ preventScroll: true });
        } catch (err) {
          /* Never leave the page locked behind a broken popup */
          root.hidden = true;
          document.documentElement.classList.remove('of-sp-lock');
          if (window.console) console.warn('[of-sp]', err);
        }
      }

      function close(isDismiss) {
        if (isDismiss && !subscribed) set('localStorage', KEYS.dismissedAt, String(Date.now()));
        root.hidden = true;
        document.documentElement.classList.remove('of-sp-lock');
        watchViewport(false);
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }

      root.querySelectorAll('[data-of-sp-dismiss]').forEach(function (el) {
        el.addEventListener('click', function () { close(true); });
      });
      root.querySelector('[data-of-sp-close]').addEventListener('click', function () { close(false); });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(true); return; }
        if (e.key !== 'Tab') return;
        var f = Array.prototype.filter.call(
          panel.querySelectorAll('button, input, a[href], [tabindex="0"]'),
          function (el) { return isVisible(el) && !el.disabled; }
        );
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });

      /* ---- Scratch foil: only the visitor removes it ---- */

      var scratchBounds = null;
      var scratchedCells = new Uint8Array(512), clearedCells = 0;
      var scratching = false;
      var foilW = 0, foilH = 0; /* size the foil was drawn at */

      function drawFoil() {
        if (!ctx && canvas.getContext) ctx = canvas.getContext('2d');
        if (!ctx) { canvas.style.display = 'none'; reveal(); return; }
        var rect = canvas.getBoundingClientRect();
        var w = rect.width, h = rect.height;
        foilW = w; foilH = h;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(w * dpr);
        canvas.height = Math.round(h * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.globalCompositeOperation = 'source-over';

        /* Silver foil with a light diagonal sheen */
        var g = ctx.createLinearGradient(0, 0, w, h);
        g.addColorStop(0, '#aeb3ba');
        g.addColorStop(0.45, '#e9ebee');
        g.addColorStop(0.55, '#dfe2e6');
        g.addColorStop(1, '#a4a9b1');
        ctx.fillStyle = g;
        ctx.fillRect(0, 0, w, h);
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.35)';
        ctx.lineWidth = 2;
        for (var x = -h; x < w; x += 14) {
          ctx.beginPath();
          ctx.moveTo(x, h);
          ctx.lineTo(x + h, 0);
          ctx.stroke();
        }

        var font = getComputedStyle(root).fontFamily;
        ctx.fillStyle = '#3f444d';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.font = '800 26px ' + font;
        ctx.fillText('SCRATCH HERE', w / 2, h / 2);
      }

      var lastPoint = null;
      function scratchAt(e) {
        var rect = scratchBounds || canvas.getBoundingClientRect();
        /* Scale to the drawn size, in case the card was resized since */
        var x = (e.clientX - rect.left) * foilW / rect.width;
        var y = (e.clientY - rect.top) * foilH / rect.height;
        ctx.globalCompositeOperation = 'destination-out';
        /* A continuous stroke from the last point, so fast swipes don't leave gaps */
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = 44;
        ctx.strokeStyle = '#000'; /* fully opaque, so the stroke removes the foil completely */
        ctx.beginPath();
        ctx.moveTo(lastPoint ? lastPoint.x : x, lastPoint ? lastPoint.y : y);
        ctx.lineTo(x, y);
        ctx.stroke();
        markScratch(lastPoint || {x:x,y:y}, {x:x,y:y});
        lastPoint = { x: x, y: y };
        if (!revealed && clearedCells / scratchedCells.length >= REVEAL_AT) reveal();
      }

      // Track a small coverage grid instead of reading the full GPU canvas on pointer moves.
      function markScratch(a, b) {
        var dx=b.x-a.x, dy=b.y-a.y, length=dx*dx+dy*dy;
        for(var row=0;row<16;row++) for(var col=0;col<32;col++) {
          var index=row*32+col;
          if(scratchedCells[index]) continue;
          var px=(col+0.5)*foilW/32, py=(row+0.5)*foilH/16;
          var t=length ? Math.max(0,Math.min(1,((px-a.x)*dx+(py-a.y)*dy)/length)) : 0;
          var ex=px-a.x-t*dx, ey=py-a.y-t*dy;
          if(ex*ex+ey*ey<=484){scratchedCells[index]=1;clearedCells++;}
        }
      }

      canvas.addEventListener('pointerdown', function (e) {
        if (!ctx) return;
        scratching = true;
        scratchBounds = canvas.getBoundingClientRect();
        if (canvas.setPointerCapture) canvas.setPointerCapture(e.pointerId);
        lastPoint = null;
        scratchAt(e);
      });
      canvas.addEventListener('pointermove', function (e) { if (scratching) scratchAt(e); });
      ['pointerup', 'pointercancel'].forEach(function (t) {
        canvas.addEventListener(t, function () { scratching = false; scratchBounds = null; });
      });
      /* Keyboard users scratch it all at once */
      canvas.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
        reveal();
      });

      function reveal() {
        if (revealed) return;
        revealed = true;
        root.classList.add('of-sp--revealed');
        title.textContent = 'Claim your discount';
        form.hidden = false;
        confetti();
        setTimeout(function () {
          if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            input.focus({ preventScroll: true });
          }
        }, 400);
      }

      function confetti() {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var colors = ['#2f7470', '#f5b301', '#e4572e', '#76b041', '#3a86ff'];
        var pieces = document.createDocumentFragment();
        for (var i = 0; i < 36; i++) {
          var c = document.createElement('span');
          c.className = 'of-sp__confetti';
          c.style.left = (35 + Math.random() * 30) + '%';
          c.style.background = colors[i % colors.length];
          c.style.setProperty('--x', (Math.random() * 360 - 180) + 'px');
          c.style.setProperty('--y', (Math.random() * 220 - 160) + 'px');
          c.style.setProperty('--r', (Math.random() * 720 - 360) + 'deg');
          pieces.appendChild(c);
          setTimeout(c.remove.bind(c), 1400);
        }
        panel.appendChild(pieces);
      }

      /* Submit to Shopify's native newsletter form. */
      form.addEventListener('submit',function(e){
        if(!input.checkValidity()){e.preventDefault();input.reportValidity();return;}
        set('sessionStorage','hs_sp_pending','1');
        submit.disabled=true;
      });

      function showError(msg) {
        error.textContent = msg;
        error.hidden = !msg;
        input.setAttribute('aria-invalid', msg ? 'true' : 'false');
      }

      function onSubscribed(email) {
        subscribed = true;
        set('localStorage', KEYS.subscribed, '1');
        offer.hidden = true;
        success.hidden = false;
        success.querySelector('[data-of-sp-copy]').focus({ preventScroll: true });

        /* Extras: each one is optional and can't block the success screen */
        try {
          fetch(root.dataset.root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(root.dataset.code), {
            credentials: 'same-origin',
            redirect: 'manual'
          }).catch(function () {});
        } catch (err) {}
        try {
          if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('of_scratch_popup_lead', {});
          }
        } catch (err) {}
      }

      /* ---- Copy code ---- */

      root.querySelector('[data-of-sp-copy]').addEventListener('click', function () {
        var btn = this;
        var code = root.dataset.code;
        var done = function () { btn.textContent = 'Copied'; setTimeout(function () { btn.textContent = 'Copy'; }, 2000); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, function(){btn.textContent='Select the code to copy';});
        } else {
          var t = document.createElement('textarea');
          t.value = code;
          t.setAttribute('readonly', '');
          t.style.position = 'fixed';
          t.style.opacity = '0';
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); } catch (err) {}
          t.remove();
          done();
        }
      });

      /* ---- Keep the card centred in the visible area, also with the keyboard open ---- */

      function onViewport() {
        var vv = window.visualViewport;
        var h = vv ? vv.height : window.innerHeight;
        if (vv) {
          root.style.setProperty('--of-sp-top', vv.offsetTop + 'px');
          root.style.setProperty('--of-sp-vh', vv.height + 'px');
        }
        root.classList.toggle('of-sp--short', h < 620);
      }
      function watchViewport(on) {
        var fn = on ? 'addEventListener' : 'removeEventListener';
        if (window.visualViewport) {
          visualViewport[fn]('resize', onViewport);
          visualViewport[fn]('scroll', onViewport);
        } else {
          window[fn]('resize', onViewport);
        }
        if (on) onViewport();
      }
      if(postSuccess){set('sessionStorage','hs_sp_pending','0');open();onSubscribed(null);}
      else if(postError){open();reveal();}
      input.addEventListener('focus', function () {
        setTimeout(function () { input.scrollIntoView({ block: 'nearest' }); }, 300);
      });
    }
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-article"]) return;
  try {
    
document.querySelectorAll('[data-hs-share]').forEach(button=>button.addEventListener('click',async()=>{const data={title:button.dataset.title,url:button.dataset.url};try{if(navigator.share){await navigator.share(data);}else{await navigator.clipboard.writeText(data.url);const status=button.parentElement.querySelector('[data-share-status]');status.classList.remove('visually-hidden');}}catch(error){if(error.name!=='AbortError')window.prompt(button.textContent.trim(),data.url);}}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-collection"]) return;
  try {
    
document.querySelectorAll('[data-hs-collection-form] select').forEach(select=>select.addEventListener('change',()=>select.form.requestSubmit()));

  } catch(e) { console.error(e); }
})();
})();
